import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "info-section"
}
const _hoisted_2 = {
  key: 2,
  class: "grid grid-cols-12 gap-5 p-10 h-full"
}
const _hoisted_3 = {
  id: "material",
  class: "col-span-12 sm:col-span-12 lg:col-span-9"
}
const _hoisted_4 = {
  key: 1,
  id: "empty",
  class: "h-[80vh]"
}
const _hoisted_5 = {
  id: "sidebar",
  class: "col-span-12 sm:col-span-12 lg:col-span-3 flex flex-col justify-center items-center bg-white rounded-lg"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "bg-neutral-200 h-[1px] mb-8 w-11/12 hidden lg:flex" }, null, -1)
const _hoisted_7 = {
  key: 0,
  id: "quiz"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalPermissionBrowser = _resolveComponent("ModalPermissionBrowser")!
  const _component_SpeechRecognition = _resolveComponent("SpeechRecognition")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Material = _resolveComponent("Material")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_ProgressCard = _resolveComponent("ProgressCard")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_QuizStudent = _resolveComponent("QuizStudent")!
  const _component_Chat = _resolveComponent("Chat")!

  return (_openBlock(), _createElementBlock("main", null, [
    (!_ctx.storeQuiz.getOpen && _ctx.loaderStore.load[1])
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createVNode(_component_ModalPermissionBrowser),
          (_ctx.hasSpeechRecognition())
            ? (_openBlock(), _createBlock(_component_SpeechRecognition, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loaderStore.load[1])
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 1,
          loader: _ctx.loaderStore.load[1]
        }, null, 8, ["loader"]))
      : (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.storeMaterial.currentMaterial?.id)
              ? (_openBlock(), _createBlock(_component_Material, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_EmptyData, {
                    data: !_ctx.storeMaterial.currentMaterial,
                    title: `${_ctx.$t('studentCourse.empty.materialBeingWatch.title')}`,
                    label: `${_ctx.$t(
              'studentCourse.empty.materialBeingWatch.description'
            )}`,
                    image: 'empty-materials-watch.svg',
                    imgSize: "h-40"
                  }, null, 8, ["data", "title", "label", "image"])
                ]))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ProgressCard),
            _hoisted_6,
            _createVNode(_component_Sidebar)
          ]),
          (_ctx.storeQuiz.getOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_QuizStudent, {
                  onOnProceed: _ctx.storeQuiz.proceedQuiz,
                  onOnEnded: _ctx.storeQuiz.quizEnded,
                  onOnClose: _ctx.storeQuiz.closeQuiz,
                  quiz: _ctx.storeQuiz.quizData,
                  quizIntro: _ctx.storeQuiz.quizIntro.quizTO,
                  quizEnded: _ctx.storeQuiz.getQuizHasEnded,
                  learningName: _ctx.storeChapter.currentChapter?.name,
                  isAdaptative: false
                }, null, 8, ["onOnProceed", "onOnEnded", "onOnClose", "quiz", "quizIntro", "quizEnded", "learningName"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_Chat, {
            onOnBackMaterial: _ctx.storeNavigation.prev,
            onOnCheckVideoEnded: _ctx.storeNavigation.next,
            indexMaterial: _ctx.storeMaterial.currentMaterialIndex,
            user: _ctx.user,
            msgType: 'default',
            hSize: `!h-[90vh]`,
            currentMaterial: _ctx.storeMaterial.currentMaterial!,
            class: "custom-chat",
            ref: "chat"
          }, null, 8, ["onOnBackMaterial", "onOnCheckVideoEnded", "indexMaterial", "user", "currentMaterial"])
        ]))
  ]))
}